import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Icon from 'flarum/common/components/Icon';
import textContrastClass from 'flarum/common/helpers/textContrastClass';
import classList from 'flarum/common/utils/classList';
import ItemList from 'flarum/common/utils/ItemList';
export default class FollowingHero extends Component {
  view() {
    const color = this.heroColor();
    return m("header", {
      className: classList('Hero', 'FollowingHero', {
        'FollowingHero--colored': color,
        [textContrastClass(color)]: color
      }),
      style: color ? {
        '--hero-bg': color
      } : undefined
    }, m("div", {
      className: "container"
    }, this.viewItems().toArray()));
  }
  viewItems() {
    const items = new ItemList();
    items.add('content', m("div", {
      className: "containerNarrow"
    }, this.contentItems().toArray()), 80);
    return items;
  }
  contentItems() {
    const items = new ItemList();
    items.add('following-title', m("h1", {
      className: "Hero-title"
    }, m(Icon, {
      name: this.heroIcon()
    }), " ", app.translator.trans('fof-follow-tags.forum.hero.title')), 100);
    return items;
  }
  heroColor() {
    // Example return a color string to display a colored hero
    //return app.forum.attribute<string>('themeSecondaryColor');
    return null;
  }
  heroIcon() {
    return 'fas fa-star';
  }
}
flarum.reg.add('fof-follow-tags', 'forum/components/FollowingHero', FollowingHero);